/** @format */

export type FieldTypeKey =
  | 'text'
  | 'numeric'
  | 'email'
  | 'url'
  | 'datetime-local'
  | 'file'

export type FieldType = Readonly<{
  key: FieldTypeKey
  displayName: string
}>

export const allFieldTypes: ReadonlyArray<FieldType> = [
  {
    key: 'text',
    displayName: 'Text',
  },
  {
    key: 'numeric',
    displayName: 'Number',
  },
  {
    key: 'email',
    displayName: 'Email',
  },
  {
    key: 'url',
    displayName: 'URL',
  },
  {
    key: 'datetime-local',
    displayName: 'DateTime',
  },
  {
    key: 'file',
    displayName: 'File',
  },
]

export function getDisplayNameForFieldType(fieldType: FieldTypeKey): string {
  return fieldTypeToDisplayName.get(fieldType) ?? 'Undefined'
}

const fieldTypeToDisplayName = new Map(
  allFieldTypes.map(({key, displayName}) => [key, displayName]),
)
